import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=58d4b78b&"
import script from "./ContentBody.vue?vue&type=script&lang=js&"
export * from "./ContentBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports